const BRAND_DEFAULT = 'Kanban Zone';

// GreenLine's Zapier integration exists but is not in the Zapier App Directory yet, so it has no
// directory slug and the embed widget renders empty. Until it is listed, /zapier stays off GreenLine
// entirely — the route as well as the nav link, or a direct URL would serve GreenLine users the
// Kanban Zone widget. To turn it on: confirm zapier.com/apps/<slug> resolves, add that slug to
// public/zapier.html, then flip this to true.
const GREENLINE_ZAPIER_PUBLISHED = false;

export const getBrandName = () => {
  if (typeof window === 'undefined') {
    return BRAND_DEFAULT;
  }

  const host = window.location.host.toLowerCase();

  if (host.includes('greenline.works')) {
    return 'GreenLine';
  }

  if (host.includes('kanbanzone.io')) {
    return 'Kanban Zone';
  }

  return BRAND_DEFAULT;
};

// The GreenLine MCP server is temporarily switched off (its Lambda is throttled to zero
// concurrency), so the /mcp page is hidden on GreenLine to avoid documenting a dead endpoint.
// Kanban Zone is unaffected. To restore: flip this to true, rebuild, deploy to both buckets, and
// lift the Lambda throttle with
//   aws lambda delete-function-concurrency --function-name McpServer_gl-prod
const GREENLINE_MCP_PUBLISHED = false;

export const isMCPAvailable = () =>
  getBrandName() !== 'GreenLine' || GREENLINE_MCP_PUBLISHED;

export const isZapierAvailable = () =>
  getBrandName() !== 'GreenLine' || GREENLINE_ZAPIER_PUBLISHED;

export const getZapierKnowledgeBaseUrl = () =>
  getBrandName() === 'GreenLine'
    ? 'https://help.greenline.legal/'
    : 'https://kanbanzone.com/knowledge-base/zapier/';

